import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cb702c36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "text"
}
const _hoisted_4 = { class: "banan" }
const _hoisted_5 = { class: "mainbox" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "加入我们", -1))
const _hoisted_7 = { class: "tabs clearfix" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-henggang" })
], -1))
const _hoisted_10 = { class: "list" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "info" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "wages" }
const _hoisted_15 = { class: "red" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "more" }, "查看详情", -1))
const _hoisted_17 = { class: "empty" }
const _hoisted_18 = {
  key: 0,
  class: "iconfont icon-queshengye_zanwushuju"
}
const _hoisted_19 = { class: "pagination" }

import {reactive, onMounted , watch ,ref} from "vue";
import Nav from '@/components/nav/Index.vue';
 
import { useRouter , useRoute } from "vue-router";
import { getAllRecruitType, getRecruit } from "@/api/backstage";
 

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
  isMobile: Boolean,
},
  setup(__props) {

const props = __props



const mb =ref('');
 watch(
  () => props.isMobile,
  (newv, oldv) => {
       props.isMobile? mb.value = true : mb.value = false;    
  }
);
 
const router = useRouter();
const route = useRoute();
 
const datas = reactive({
  banner:'',
  total:0,
  items:[],
  filurl:localStorage.getItem('fileUrel'),
  posType:[],
  form: {
    posTypeId: "",
    pageNum: 1,
    pageSize: 8,
  },
});

 


const getData = () =>{
  getRecruit(datas.form).then((res: any) =>{
      for(const item of res.data.list){
      if(item.fileName) item.fileurl = localStorage.getItem("fileUrel") + item.fileName;
    }
    datas.items = res.data.list;
    datas.total = res.data.total;
  });
};

const getRecruitType = () =>{
  getAllRecruitType().then((res: any) =>{
    for(const item of res.data) {
       item.checked = false;
     }
     res.data.unshift({title:'全部',id:'',checked:true});
     datas.posType = res.data;
  });
};
 


 

const handleCurrentChange = (val: number) => {
  datas.form.pageNum = val;
  getData();
};


const onchecked = (i) => {
  for(const item of datas.posType) {
    item.checked = false;
  }
  datas.form.posTypeId = datas.posType[i].id;
  datas.posType[i].checked = true;
  getData();
};

const linkto = (item) => {
  window.open(item.linkUrl, '_blank');
};

const getBanner = (banner) => {
  datas.banner = banner;
};




onMounted(() => {
  getData();
  getRecruitType();
  mb.value =props.isMobile;
});

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(mb.value?'Mobile':'pc')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Nav, {
        style: 'ww',
        isMobile: mb.value,
        onGetBanner: getBanner
      }, null, 8, ["isMobile"]),
      (datas.banner.length==1)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: datas.filurl+datas.banner[0].fileName,
            alt: ""
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      (datas.banner.length==1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(datas.banner[0].title), 1),
            _createElementVNode("p", null, _toDisplayString(datas.banner[0].description), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.posType, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: _normalizeClass({check:item.checked}),
              onClick: ($event: any) => (onchecked(index))
            }, [
              _createTextVNode(_toDisplayString(item.title), 1),
              _hoisted_9
            ], 10, _hoisted_8))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.items, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            style: {"cursor":"pointer"},
            onClick: ($event: any) => (linkto(item)),
            class: "item",
            key: index
          }, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h3", null, [
                _createTextVNode(_toDisplayString(item.title) + " ", 1),
                (item.urgencyStatus==1)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_13, "急"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", null, [
                _createTextVNode("发布时间：" + _toDisplayString(item.createTime.slice(0,10)) + " ", 1),
                _createElementVNode("span", null, _toDisplayString(item.description), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h3", _hoisted_15, _toDisplayString(item.wages), 1),
              _hoisted_16
            ])
          ], 8, _hoisted_11))
        }), 128)),
        _createElementVNode("div", _hoisted_17, [
          (!datas.items.length)
            ? (_openBlock(), _createElementBlock("i", _hoisted_18))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_el_pagination, {
          background: "",
          layout: "prev, pager, next",
          "page-size": datas.form.pageSize,
          onCurrentChange: handleCurrentChange,
          total: datas.total
        }, null, 8, ["page-size", "total"])
      ])
    ])
  ], 2))
}
}

})